import Backbone from 'backbone';

export default Backbone.Model.extend({
    idAttribute: 'app',
    backend: 'gcapi',
    urlRoot: '/info-service/api/system/release-system',

    parse: function(response) {
        if (response) {
            return response[0];
        }
    }
});
